export enum ReservationStatus {
  PRE_ARRIVAL1 = 1,
  PRE_ARRIVAL2 = 6,
  IN_HOUSE = 2,
  CHECKED_OUT = 3,
  CANCELLED = 4,
  NO_SHOW = 5,
  WAIT_LIST = 7,
  DUE_OUT = 8,
}

export enum OccupancyStatus {
  Vacant = 'vacant',
  PreArrival = 'pre-arrival',
  InHouse = 'inhouse',
  DueOut = 'due-out',
  DueOutPreArrival = 'due-out-pre-arrival',
}

export const OccupancyStatus_ResStatus: Readonly<
  {
    [key in OccupancyStatus]: ReservationStatus;
  }
> = {
  [OccupancyStatus.Vacant]: ReservationStatus.IN_HOUSE,
  [OccupancyStatus.PreArrival]: ReservationStatus.PRE_ARRIVAL1,
  [OccupancyStatus.InHouse]: ReservationStatus.IN_HOUSE,
  [OccupancyStatus.DueOut]: ReservationStatus.IN_HOUSE,
  [OccupancyStatus.DueOutPreArrival]: null,
};
